import { MINT } from "@src/core/constants/images";
import { useContext, useEffect, useState } from "react";
import { handleLoginViaICONex } from "@services/icon";
import { handleLoginViaLedger } from "@services/ledger";
import { walletContext } from "@src/core/context/walletContext";
import AppIcx from "@ledgerhq/hw-app-icx";
// @ts-ignore
import Transport from "@ledgerhq/hw-transport-webhid";
import Modal from "./Modal.component";
import LedgerAddressModal from "./LedgerAddressModal.component";
import { ledgerContext } from "@src/core/context/ledgerContext";
import { WALLET_TYPE } from "@enum/walletType.enum";
import { setTimeout } from "timers/promises";

const WalletModal = ({ setPopupOpen }: any) => {
  const walletContextValue = useContext(walletContext);
  const [walletConnection, setWalletConnection] = useState(false);

  const [transport, setTransport] = useState<any>(null);
  const [icx, setIcx] = useState<any>(null);
  const [walletPaths, setWalletPaths] = useState<any>([]);
  const [hasLedgerSupport, setHasLedgerSupport] = useState<boolean>(false);
  const [isAddressLoading, setIsAddressLoading] = useState<boolean>(false);

  const ledgerContextValue = useContext(ledgerContext); //ledgerInfo->ledgerPath, ledgerTransport //setLedgerInfo

  // Pagination
  const [currPage, setCurrPage] = useState(1);
  const [wallets, setWallets] = useState([]);

  const BASE_PATH = `44'/4801368'/0'/0'`;
  const addressPerPage = 8;
  const iconexExtension =
    "https://chrome.google.com/webstore/detail/iconex/flpiciilemghbmfalicajoolhkkenfel?hl=en";

  const loadAddresses = async (suppressError: any, icx: any) => {
    let i = 0;
    let counter;
    const addresses: string[] = [];
    const paths = [];
    setIsAddressLoading(true);
    while (i < addressPerPage) {
      try {
        suppressError = true;
        counter = (currPage - 1) * addressPerPage + i;
        const path = `${BASE_PATH}/${counter}'`;

        let { address } = await icx.getAddress(path, false, true);

        address = address.toString();
        addresses.push(address);
        paths.push(path);
        console.log("Ledger is connected!!!");
        walletContextValue.type = WALLET_TYPE.LEDGER;
      } catch (error) {
        console.log("Failed to load addresses.");
        console.log(error);
      }
      i++;
    }

    if (addresses.length === 0) {
      // alert("Your ledger is busy, please re-connect it.");
    }

    setIsAddressLoading(false);
    // @ts-ignore
    setWallets(addresses);
    setWalletPaths(paths);
  };

  const connectToLedger = () => {
    let suppressError = false;

    Transport.create()
      .then(async (transport: any) => {
        transport.setDebugMode(true);
        setTransport(transport);
        const icx = new AppIcx(transport);
        setIcx(icx);
        try {
          console.log("Connection successful! ");
          setHasLedgerSupport(true);
          // @ts-ignore
          await icx.getAddress(`${BASE_PATH}/0'`, false, true);
          await loadAddresses(suppressError, icx);
          // setIsConnecting(false);
        } catch (error) {
          console.log("Failed connecting to ledger!");
          setHasLedgerSupport(false);
        }
      })
      .catch((error: any) => {
        if (error.name === "TransportOpenUserCancelled") {
          console.log("Cancelled!");
        } else {
          console.log(error);
          alert("Please re-connect your ledger to icon network.");
        }
      });
  };

  const onNext = () => {
    setCurrPage((prev) => prev + 1);
  };

  const onPrevious = () => {
    setCurrPage((prev) => prev - 1);
  };

  const firstPage = () => {
    setCurrPage(1);
  };

  useEffect(() => {
    if (hasLedgerSupport) {
      loadAddresses(false, icx);
    }
  }, [currPage, hasLedgerSupport]);

  useEffect(() => {
    if (wallets.length) {
      setWalletConnection(true);
    }
  }, [wallets]);

  const handleConfirmation = async (selectedWallet: string, path: string) => {
    walletContextValue.address = selectedWallet;
    ledgerContextValue.setLedgerInfo({
      ledgerPath: path,
      ledgerTransport: transport,
    });
    setCurrPage(1);
  };

  const handleClose = () => {
    setWalletConnection(false);
  };

  useEffect(() => {
    if (walletContextValue.address) {
      setPopupOpen(false);
    }
  }, [walletContextValue.address]);

  return (
    <>
      <Modal
        setPopupOpen={setPopupOpen}
        title="Connect your wallet"
        style={{ width: "743px" }}
      >
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="modal-btn-wrapper"
              onClick={() => {
                handleLoginViaICONex();
              }}
            >
              <img src={MINT.ICONBTN} alt="Icon button" />
              <div className="modal-btn-text">ICONex</div>
            </div>
            <div
              className="modal-btn-wrapper"
              onClick={() => {
                // handleLoginViaLedger();
                connectToLedger();
              }}
            >
              <img src={MINT.LEDGERBTN} alt="Ledger button" />
              <div className="modal-btn-text">Ledger</div>
            </div>
          </div>
          <p
            style={{
              marginTop: "10px",
              fontSize: "13px",
              textAlign: "center",
              padding: "10px",
            }}
          >
            if you do not have ICONex wallet installed, please download from{" "}
            <span
              onClick={() => {
                window.open(iconexExtension, "_blank");
              }}
              style={{ color: "var(--primary-color)", cursor: "pointer" }}
            >
              here
            </span>{" "}
            and try again.
          </p>
        </div>
      </Modal>

      {walletConnection && (
        <LedgerAddressModal
          isVisible={walletConnection}
          onClose={handleClose}
          onConfirm={handleConfirmation}
          onNext={onNext}
          onPrevious={onPrevious}
          firstPage={firstPage}
          currentPage={currPage}
          addressList={wallets}
          walletPaths={walletPaths}
          isAddressLoading={isAddressLoading}
          setConnectWalletPopup={setPopupOpen}
        />
      )}
    </>
  );
};

export default WalletModal;
